/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'alert-circle': {
    width: 25,
    height: 24,
    viewBox: '0 0 25 24',
    data: '<path d="M12.5 23C6.4 23 1.5 18.1 1.5 12C1.5 5.9 6.4 1 12.5 1C18.6 1 23.5 5.9 23.5 12C23.5 18.1 18.6 23 12.5 23ZM12.5 3C7.5 3 3.5 7 3.5 12C3.5 17 7.5 21 12.5 21C17.5 21 21.5 17 21.5 12C21.5 7 17.5 3 12.5 3Z" fill="white"/><path d="M12.5 13C11.9 13 11.5 12.6 11.5 12V8C11.5 7.4 11.9 7 12.5 7C13.1 7 13.5 7.4 13.5 8V12C13.5 12.6 13.1 13 12.5 13Z" fill="white"/><path d="M12.5 17C12.2 17 12 16.9 11.8 16.7C11.6 16.5 11.5 16.3 11.5 16C11.5 15.9 11.5 15.7 11.6 15.6C11.7 15.5 11.7 15.4 11.8 15.3C12.1 15 12.5 14.9 12.9 15.1C13 15.1 13 15.1 13.1 15.2C13.1 15.2 13.2 15.3 13.3 15.3C13.4 15.4 13.5 15.5 13.5 15.6C13.5 15.7 13.5 15.9 13.5 16C13.5 16.1 13.5 16.3 13.4 16.4C13.3 16.5 13.3 16.6 13.2 16.7C13 16.9 12.8 17 12.5 17Z" fill="white"/>'
  }
})







